(function ($) {
    new Vue({
        el: '#topNav',
        data: {
            // 导航列表
            itemList: '',
        },
        mounted: function () {
            this.getSidebarData();
            this.initSwiper();
        },
        methods: {
            // 获取侧边栏数据
            getSidebarData: function () {
                var _this = this;
                var info = {
                    platform: location.href.indexOf('latest-dell-products') > -1 ? 'ai_pc' : 'normal',
                    type: 'wap'
                }
                common.getJson(solution_host + '/api/shop/sidebar', info, function (res) {
                    console.log(res);
                    _this.itemList = res.data.items;
                });
            },

            // swiper 初始化
            initSwiper: function () {
                var _this = this;
                this.$nextTick(function () {
                    _this.mySwiper = new Swiper('#topNav .swiper-container', {
                        autoplay: false,
                        centerInsufficientSlides: true,
                        // 显示6个
                        slidesPerView: 6,
                        // 默认显示第一个
                        initialSlide: 1,
                        // 父级修改了宽度，子级也跟着修改
                        observer: true,
                        observeParents: true,
                        navigation: {
                            nextEl: '#topNav .swiper-button-next',
                            prevEl: '#topNav .swiper-button-prev',
                        },
                    });
                    setTimeout(function () {
                        if ($('#topNav .swiper-container').length) _this.mySwiper.slideTo(0, 10, false); //切换到第一个slide，速度为1秒
                    }, 0)
                })
            },

            // 点击
            itemClick: function (item) {
                if (item.tag) {
                    gioTrackAction.gio_base(item.tag, {
                        'iconname': item.title
                    });
                }
                switch (item.custom) {
                    case 'url':
                        common.gotoUrl(item.url);
                        break;
                    case 'gzh':
                        msg.show(document.querySelector('.dialog-box.gzh-dialog'));
                        break;
                    case 'kefu':
                        qidiankefu.open(3);
                        break;
                    case 'tel':
                        window.location.href = 'tel:400-884-6610';
                        break;
                }

            },
        }
    });
}(jQuery));
